import React from "react";
import avatar from "../../assets/avatar.png";
import SOCIAl_BUTTONS from "../../data/SocialButtonsData";
import SocialButtons from "./SocialButtons";
import Logo from "./Logo";
import { MdOutlineDownloading } from "react-icons/md";


const PortfolioCard = () => {
  return (
    <div className="relative h-full mb-12 border-2 rounded-lg border-darkTheme-bg-tertiary bg-darkTheme-bg-secondary">
      <div className="px-6 pt-8">
        <Logo />
      </div>
      <div className="px-4 pt-0 pb-16 my-2">
        <div className="relative flex flex-col items-center justify-center gap-4 mb-8">
          <figure className="w-64">
            <img src={avatar} alt="Mohammed Shibin" />
          </figure>

          <div className="mt-4 text-center">
            <h1 className="py-2 text-xl">Mohammed Shibin V</h1>
            <p className="text-sm">Software Developer | CSE Graduate</p>
          </div>
        </div>

        <div className="flex justify-around">
          {SOCIAl_BUTTONS.map((button, index) => (
            <SocialButtons key={index} href={button.href} icon={button.icon} />
          ))}
        </div>
      </div>

      <div className="absolute right-8 bottom-8 ">
        <button class="group relative inline-flex items-center justify-center overflow-hidden border-primary p-4 px-6 py-3 font-medium">
          <span class="invisible relative">Button Text</span>
          <span class="ease absolute flex h-full w-full transform items-center justify-center text-darkTheme-accent-primary transition-all duration-300 group-hover:translate-x-full">Download CV</span>
          <span class="ease absolute inset-0 flex h-full w-full -translate-x-full items-center justify-center bg-darkTheme-accent-primary duration-300 group-hover:translate-x-0">
            <MdOutlineDownloading className="text-xl" />
          </span>
        </button>
      </div>
    </div>
  );
};

export default PortfolioCard;
